import styles from './RatesPage.module.scss'
import { useNavigate } from "react-router-dom"
import {useIsAuth} from '../../hooks/auth'
import useHasRate from "../../hooks/useHasRate"
import { useEffect } from "react"
import { FILTERS_URL, VACANCIES_URL } from "../../utils/consts"
import Layout from '../../ui/Layout/Layout'
import Button from '../../ui/Button/Button'



const RatesPage = () => {
  const navigate = useNavigate()

  const isAuth = useIsAuth()
  const hasRate = useHasRate()

  useEffect(() => {
    if (!isAuth.data) {
      navigate('/')
    }
    if (hasRate) {
      navigate(VACANCIES_URL)
    }
  }, [navigate, isAuth, hasRate])

  return (
    <div className={styles.ratesPage}>

      <Layout className={styles.rate}>
        <span>
          <h1>1 Месяц</h1>
          <p>Экономный вариант, если уверены в своих силах.</p>
        </span>
        <Button><p>Приобрести</p></Button>
        <h2>250 Р</h2>
      </Layout>

      <Layout className={styles.rate} kind='white'>
        <span>
          <h1>3 Дня</h1>
          <p>Пробный период, чтобы ознакомиться с работой сервиса.</p>
        </span>
        <Button style={{
          backgroundColor: 'black',
          color: 'white',
        }}><p>Попробовать</p></Button>
        <h2>0 Р</h2>
      </Layout>

      <Layout className={styles.rate}>
        <span>
          <h1>3 Месяца</h1>
          <p>Этого времени должно хватить, чтобы найти подходящую работу.</p>
        </span>
        <Button><p>Приобрести</p></Button>
        <h2>500 Р</h2>
      </Layout>
    </div>
  )
}

export default RatesPage